import { api } from '@/lib/axios';
import type { Page } from '@/services/chantiers';

export type AOType = 'PUBLIC' | 'PRIVE' | 'GRE_A_GRE';
export type AOStatut = 'IDENTIFIE' | 'EN_COURS' | 'DEPOSE' | 'REMPORTE' | 'PERDU' | 'ANNULE';
export type MarcheStatut = 'EN_COURS' | 'SUSPENDU' | 'ACHEVE' | 'RESILIE';

export interface AppelOffreDTO {
  id: string;
  reference: string;
  intitule: string;
  type: AOType;
  wilaya_id: number | null;
  date_limite_depot: string | null;
  montant_estimatif: number | null;
  caution_soumission: number | null;
  statut: AOStatut;
  notes: string | null;
  is_archived: boolean;
}

export interface AppelOffreInput {
  reference: string;
  intitule: string;
  type: AOType;
  montant_estimatif?: number | null;
  caution_soumission?: number | null;
  date_limite_depot?: string | null;
  statut: AOStatut;
}

export interface MarcheDTO {
  id: string;
  reference_marche: string;
  intitule: string;
  montant_contractuel: number;
  statut: MarcheStatut;
  taux_avancement: number;
  montant_facture_cumul: number;
  montant_encaisse_cumul: number;
  date_debut: string | null;
  date_fin_prevue: string | null;
}

export const AO_STATUTS: AOStatut[] = ['IDENTIFIE', 'EN_COURS', 'DEPOSE', 'REMPORTE', 'PERDU', 'ANNULE'];

export async function listAppelsOffres(params?: { q?: string; statut?: AOStatut; archives?: boolean }): Promise<Page<AppelOffreDTO>> {
  const { data } = await api.get<Page<AppelOffreDTO>>('/appels-offres', { params });
  return data;
}

export async function createAppelOffre(payload: AppelOffreInput): Promise<AppelOffreDTO> {
  const { data } = await api.post<AppelOffreDTO>('/appels-offres', payload);
  return data;
}

export async function updateAppelOffre(id: string, payload: Partial<AppelOffreInput> & { is_archived?: boolean }): Promise<AppelOffreDTO> {
  const { data } = await api.put<AppelOffreDTO>(`/appels-offres/${id}`, payload);
  return data;
}

export async function deleteAppelOffre(id: string): Promise<void> {
  await api.delete(`/appels-offres/${id}`);
}

export async function convertirEnMarche(aoId: string): Promise<MarcheDTO> {
  const { data } = await api.post<MarcheDTO>(`/appels-offres/${aoId}/convertir`);
  return data;
}

export async function listMarches(params?: { q?: string; statut?: MarcheStatut }): Promise<Page<MarcheDTO>> {
  const { data } = await api.get<Page<MarcheDTO>>('/marches', { params });
  return data;
}
